import styled from 'styled-components';

export const Container = styled.div`
    margin: 0 auto 1rem;
    max-width: 500px;
    h1{
      margin-bottom: 24px;
    }

    h1 + form > input {
      margin-bottom: 16px;
    }
`;
